import type { OnboardingQuestionnaireConcludeFields } from './types';

/** Submit returns conclude metadata only — merge into an existing row so nested/list data stays intact. */
export function patchOnboardingQuestionnaireConcludeFields<
  TRow extends OnboardingQuestionnaireConcludeFields,
>(row: TRow, payload: OnboardingQuestionnaireConcludeFields): TRow {
  return {
    ...row,
    status: payload.status,
    date_concluded: payload.date_concluded ?? row.date_concluded,
    date_concluded_utc_offset: payload.date_concluded_utc_offset ?? row.date_concluded_utc_offset,
  };
}
